import { render, staticRenderFns } from "./LinkDropdown.vue?vue&type=template&id=0ca275f4&"
import script from "./LinkDropdown.vue?vue&type=script&lang=js&"
export * from "./LinkDropdown.vue?vue&type=script&lang=js&"
import style0 from "./LinkDropdown.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports